// extracted by mini-css-extract-plugin
export default {"root":"Visualization_root__wAMRy","bottom":"Visualization_bottom__TxYtc"};